const requireFlag = require.context('./webp', false, /\.webp$/);

export const flags = requireFlag.keys().reduce((acc, file) => {
  const key = file.replace('./', '').replace('.webp', '');
  acc[key] = requireFlag(file);
  return acc;
}, {});
